import {ID, Response} from '../../../../../_metronic/helpers'

export type TimeTracking = {
  id?: ID
  begin_date?: string
  end_time?: string
  total_time?: ID
  user_id?: ID
  task_id?: ID
  finished?: boolean
  play?: boolean
  type?: string
  date?: string
  message?: string
  code?: number
}

export type ResponseTimeTracking = {
  timetracking: TimeTracking
  message: string
  errors: boolean
}


export type TimeTrackingQueryResponse = Response<Array<TimeTracking>>

/** Data local YYYY-MM-DD (evita toISOString/UTC que após 21h BRT vira o dia seguinte). */
export const getLocalDateString = (date: Date = new Date()): string => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export const initialTimeTracking: TimeTracking = {
  begin_date: '',
  end_time: '',
  finished: false,
  play: false,
  type: '',
  date: getLocalDateString()
}

export type StepProps = {
  data: TimeTracking,
  updateData: (fieldsToUpdate: Partial<TimeTracking>) => void,
  hasError: boolean
}